export class ClienteIntegracaoImportFilter {
    idIntegracao: number;
    codigoIntegracao: string;
    cnpjCpf: string;
    cnpjsCpfs: string[] = [];
    nome: string;
    email: string;
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;
}
